// import { useProductFeature } from '@src/pages/[...slug]/components/product/productFeatureProvider'

import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useNewPdpDesignV2Bucket = () => {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.NEW_PDP_DESIGN_V2)
  return experimentBucket
}

export const DISABLE_PARTIAL_V2_DESIGN = true
